import { Buffer } from "buffer";

// host name
const CURRENT_HOST: string | undefined = process.env.REACT_APP_BASE_URL_FINDER;

// types of methods
export const method: {
  DELETE: string;
  POST: string;
  GET: string;
  PUT: string;
  PATCH: string;
  OPTIONS: string;
} = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  PATCH: "PATCH",
  DELETE: "DELETE",
  OPTIONS: "OPTIONS",
};

//TODO
const credentials = {
  Username: "",
  Password: "i luv Kshema",
};

// api paths
export const paths = {
  // base URL
  BASE_URL: CURRENT_HOST,
  // Encode credentials in Base64
  basicAuthString: Buffer.from(
    `${credentials.Username}:${credentials.Password}`,
  ).toString("base64"),
  DISTRICT_GRID_VIEW: "/districts/geoserver",
  STATE_GRID_VIEW: "/gridview",
  STATES_DATA: "/states",
  DISTRICTS_DATA: "/districts",
  DISTRICT: "/districts",
  DISTRICT_DATA: "/districts/data",
  POSP_GRID_DISTANCE: "/posps/details",
  UNIVERSITY_GRID_DISTANCE: "/universities/details",
  LOGIN: "/auth/login",
  COUNTRY_STATE_WISE: "/grid/country/dates",
  COUNTRY_GRID_WISE: "/stateview/country/filter",
  LOGOUT: "/auth/logout",
  GRID_DETAILS: "/grid/details",
  STATE_VIEW_DATA: "/stateview/filter",
  STATE_VIEW_DATA_V2: "/stateview/v2/filters",
  GRID_GEOMETRY: "/grid/geometry",
  LEVEL_ONE: "/stateview/level1",
  LEVEL_TWO: "/stateview/level2",
  LEVEL_THREE: "/crops/",
  CONSOLIDATED_BUSINESS_STATE_WISE: "/consolidated/state",
  CONSOLIDATED_BUSINESS_DISTRICT_WISE: "/consolidated/district",
  CONSOLIDATED_BUSINESS_GRID_WISE: "/consolidated/grid",
  CONSOLIDATED_MAN_POWER: "/consolidated/posp",
  SEASONS: "/stateview/seasonid",
  PRODUCTS: "/stateview/productid",
  NOC_CROP_METRICS: "/nocview/crop-metrics",
  LATEST_COMPUTED_DATE: "/forecast/latest-computed-date",
  WMS_URL: process.env.REACT_APP_BASE_URL_WMS + "/geoserver/kshema/wms?",
  GWC_URL_COUNTRY:
    process.env.REACT_APP_BASE_URL_WMS +
    "/geoserver/gwc/service/tms/1.0.0/kshema:stateinfo@EPSG%3A900913@pbf/{z}/{x}/{-y}.pbf",
  GWC_URL_STATE:
    process.env.REACT_APP_BASE_URL_WMS +
    "/geoserver/kshema/gwc/service/wmts?layer=kshema:grid_stateview&tilematrixset=EPSG:900913&Service=WMTS&Request=GetTile&Version=1.0.0&Format=application/x-protobuf;type=mapbox-vector&TileMatrix=EPSG:900913:{z}&TileCol={x}&TileRow={y}",
  TILE_URL: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
  MBTILE_URL:
    process.env.REACT_APP_BASE_URL_FINDER + "/tiles/mbtiles/{z}/{x}/{y}.pbf",
  COUNTRY_STATE_MBTILE_URL:
    process.env.REACT_APP_BASE_URL_FINDER +
    "/tiles/country-state/{z}/{x}/{y}.pbf",
  COUNTRY_GRID_MBTILE_URL:
    process.env.REACT_APP_BASE_URL_FINDER +
    "/tiles/country-grid/{z}/{x}/{y}.pbf",
  STATE_VIEW_MBTILE_URL:
    process.env.REACT_APP_BASE_URL_FINDER + "/tiles/stateview/{z}/{x}/{y}.pbf",
  GRID_LAT_LNG: "/stateview/lat-lon",
  WEATHER_WMS_URL: process.env.REACT_APP_WHETHER_WMS_URL,
  WEATHER_MANAGEMENT: process.env.REACT_APP_WHETHER_MANAGEMENT,
};
